import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './EducationalFullContent.css';

const EducationalFullContent = ({ onClose, initialNews }) => {
  const [news, setNews] = useState(initialNews || []);
  const [allNews, setAllNews] = useState([]);
  const [images, setImages] = useState({});
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [visibleCount, setVisibleCount] = useState(10);

  const handleImageError = (id) => {
    setImages(prev => ({ ...prev, [id]: false }));
  };

  useEffect(() => {
    const fetchAllNews = async () => {
      setLoading(true);
      try {
        const data = await api.getNews();
        const activeNews = data.filter(item => item.is_active === 1);
        setAllNews(activeNews);
        // Инициализируем images для всех новостей
        const initialImages = {};
        activeNews.forEach(item => {
          initialImages[item.id] = true;
        });
        setImages(initialImages);
        if (!initialNews || initialNews.length === 0) {
          setNews(activeNews.slice(0, visibleCount));
        }
      } catch (error) {
        console.error('Ошибка загрузки новостей:', error);
      } finally {
        setLoading(false);
      }
    };
    
    if (!initialNews) {
      fetchAllNews();
    } else {
      setAllNews(initialNews);
      const initialImages = {};
      initialNews.forEach(item => {
        initialImages[item.id] = true;
      });
      setImages(initialImages);
    }
  }, [initialNews]);

  useEffect(() => {
    let filtered = allNews;
    
    if (activeCategory !== 'all') {
      filtered = allNews.filter(item => item.category === activeCategory);
    }
    
    setNews(filtered.slice(0, visibleCount));
  }, [activeCategory, allNews, visibleCount]);

  const loadMore = () => {
    setVisibleCount(prev => prev + 10);
  };

  const getContentType = (item) => {
    if (item.video_url) return 'video';
    return 'image';
  };

  const getCategoryLabel = (item) => {
    if (item.category === 'video') return { label: 'Видео', icon: '🎬' };
    if (item.category === 'promo') return { label: 'Акция', icon: '🎁' };
    return { label: 'Новость', icon: '📰' };
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  const renderImage = (item) => {
    const imageUrl = item.image_url && item.image_url !== '' ? item.image_url : null;
    const isVideo = getContentType(item) === 'video';
    
    if (images[item.id] === false || !imageUrl) {
      return (
        <div className="full-card-image-container placeholder-image">
          <div style={{ textAlign: 'center' }}>
            <span style={{ fontSize: '40px', display: 'block' }}>📷</span>
            <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)' }}>Нет фото</span>
          </div>
        </div>
      );
    }

    return (
      <div 
        className={isVideo ? 'full-video-container' : 'full-card-image-container'}
        style={{ '--bg-image': `url(${imageUrl})` }}
      >
        <img 
          src={imageUrl}
          alt={item.title}
          className="full-card-image"
          loading="lazy"
          onError={() => handleImageError(item.id)}
        />
        {isVideo && <div className="full-play-icon">▶</div>}
      </div>
    );
  };

  const handleCardClick = (item) => {
    setSelectedItem(item);
  };

  const DetailModal = ({ item, onClose }) => {
    if (!item) return null;
    const isVideo = getContentType(item) === 'video';
    const category = getCategoryLabel(item);

    return (
      <div className="video-modal-overlay" onClick={onClose}>
        <div className="video-modal" onClick={(e) => e.stopPropagation()}>
          <div className="video-modal-header">
            <h3>
              <span style={{ marginRight: '8px' }}>{category.icon}</span>
              {item.title}
            </h3>
            <button className="modal-close-btn" onClick={onClose}>✕</button>
          </div>
          
          <div className="video-modal-content">
            {isVideo ? (
              <div>
                <div className="video-player-placeholder">
                  <div className="video-player-thumbnail" style={{ 
                    backgroundImage: item.image_url ? `url(${item.image_url})` : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}>
                    <div className="video-player-play-icon">▶</div>
                  </div>
                </div>
                {item.video_url && (
                  <div className="video-actions" style={{ marginTop: '16px' }}>
                    <a 
                      href={item.video_url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="video-action-btn primary-btn"
                      style={{ display: 'inline-block', textDecoration: 'none', textAlign: 'center', width: '100%' }}
                    >
                      <span>▶ Смотреть на {item.video_type === 'rutube' ? 'Rutube' : 'YouTube'}</span>
                    </a>
                  </div>
                )}
              </div>
            ) : (
              <div className="article-content">
                {item.image_url && (
                  <img 
                    src={item.image_url} 
                    alt={item.title}
                    className="article-image"
                    style={{ width: '100%', borderRadius: '12px', marginBottom: '16px' }}
                  />
                )}
                <div className="article-description">
                  {item.description && <p><strong>Описание:</strong> {item.description}</p>}
                  {item.content && <p style={{ marginTop: '12px' }}>{item.content}</p>}
                </div>
              </div>
            )}
            
            <div className="video-info-bar" style={{ marginTop: '16px', padding: '12px', background: 'rgba(255,255,255,0.05)', borderRadius: '12px' }}>
              <span>📅 {formatDate(item.created_at)}</span>
              {item.views && <span style={{ marginLeft: '16px' }}>👁️ {item.views} просмотров</span>}
            </div>
          </div>
          
          <div className="video-actions" style={{ padding: '16px 24px 24px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
            <button className="video-action-btn primary-btn" onClick={onClose} style={{ width: '100%' }}>
              <span>Закрыть</span>
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="educational-full-content">
      <div className="full-header">
        <button className="full-back-btn" onClick={onClose}>
          <span className="back-arrow">←</span>
          <span>Назад</span>
        </button>
        <h1 className="full-title">Образовательные материалы</h1>
      </div>

      <div className="full-categories">
        <button 
          className={`full-category-btn ${activeCategory === 'all' ? 'active' : ''}`}
          onClick={() => setActiveCategory('all')}
        >
          Все
        </button>
        <button 
          className={`full-category-btn ${activeCategory === 'news' ? 'active' : ''}`}
          onClick={() => setActiveCategory('news')}
        >
          Новости
        </button>
        <button 
          className={`full-category-btn ${activeCategory === 'video' ? 'active' : ''}`}
          onClick={() => setActiveCategory('video')}
        >
          Видео
        </button>
        <button 
          className={`full-category-btn ${activeCategory === 'promo' ? 'active' : ''}`}
          onClick={() => setActiveCategory('promo')}
        >
          Акции
        </button>
      </div>

      {loading ? (
        <div className="loading-spinner" style={{ textAlign: 'center', padding: '40px', color: 'white' }}>
          Загрузка...
        </div>
      ) : (
        <>
          <div className="full-grid">
            {news.map(item => {
              const category = getCategoryLabel(item);
              return (
                <div key={item.id} className="full-card" onClick={() => handleCardClick(item)}>
                  {renderImage(item)}
                  <div className="full-card-content">
                    <div className="full-card-category">
                      {category.icon} {category.label}
                    </div>
                    <div className="full-card-title">{item.title}</div>
                    <div className="full-card-description">
                      {item.description?.substring(0, 100)}
                      {item.description?.length > 100 ? '...' : ''}
                    </div>
                    <div className="full-card-footer">
                      <span className="full-card-date">{formatDate(item.created_at)}</span>
                      <button className="full-card-btn">
                        {getContentType(item) === 'video' ? 'Смотреть' : 'Читать'}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {visibleCount < allNews.length && (
            <div className="full-load-more">
              <button className="load-more-btn" onClick={loadMore}>
                Загрузить еще
              </button>
            </div>
          )}
        </>
      )}

      <DetailModal item={selectedItem} onClose={() => setSelectedItem(null)} />
    </div>
  );
};

export default EducationalFullContent;